__turbopack_context__.v({
  "className": "jetbrains_mono_a145b5e7-module__jMfsEq__className",
});
